import { StatsRangeRequest, SummaryResponse, GroupedSummaryResponse, DualDataResponse } from '../../../../models/paymentSummary';
import { HttpService } from '../../../../common/api/httpService';

export class PaymentSummaryApi {
    private static httpService = HttpService.getInstance();

    static async getSummary(request: StatsRangeRequest): Promise<SummaryResponse> {
        try {
            const result = await this.httpService.adminFetch('Payments/summary', 'POST', request);
            if (result.result && result.value) {
                return result.value as SummaryResponse;
            }
            throw new Error('Failed to load payment summary');
        } catch (error) {
            console.error('Error fetching payment summary:', error);
            throw error;
        }
    }

    static async getGroupedSummary(request: StatsRangeRequest): Promise<GroupedSummaryResponse> {
        try {
            const result = await this.httpService.adminFetch('Payments/summary/grouped', 'POST', request);
            if (result.result && result.value) {
                return result.value as GroupedSummaryResponse;
            }
            throw new Error('Failed to load grouped payment summary');
        } catch (error) {
            console.error('Error fetching grouped payment summary:', error);
            throw error;
        }
    }

    static async getProfit(request: StatsRangeRequest): Promise<DualDataResponse> {
        try {
            const result = await this.httpService.adminFetch('Payments/profit', 'POST', request);
            if (result.result && result.value) {
                return result.value as DualDataResponse;
            }
            throw new Error('Failed to load profit data');
        } catch (error) {
            console.error('Error fetching profit data:', error);
            throw error;
        }
    }

    static async getAmounts(request: StatsRangeRequest): Promise<DualDataResponse> {
        try {
            const result = await this.httpService.adminFetch('Payments/amounts', 'POST', request);
            if (result.result && result.value) {
                return result.value as DualDataResponse;
            }
            throw new Error('Failed to load amounts data');
        } catch (error) {
            console.error('Error fetching amounts data:', error);
            throw error;
        }
    }

    static async getCounts(request: StatsRangeRequest): Promise<DualDataResponse> {
        try {
            const result = await this.httpService.adminFetch('Payments/counts', 'POST', request);
            if (result.result && result.value) {
                return result.value as DualDataResponse;
            }
            throw new Error('Failed to load counts data');
        } catch (error) {
            console.error('Error fetching counts data:', error);
            throw error;
        }
    }
}
